import { useState } from "react";
import "./AdminProfileModal.css";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { CircularProgress } from "@mui/material";
import { handleUpdatePassword } from "../../services/api/admin";
import { toast } from "react-toastify";
import { handleToast } from "../../utils";
import { useNavigate } from "react-router-dom";

export default function AdminProfileModal({ openBox, setOpenBox }) {
  const data = JSON.parse(localStorage.getItem("data"));
  const [password, setPassword] = useState(false);
  const [hide, setHide] = useState(true);
  const [hide2, setHide2] = useState(true);
  const [hide3, setHide3] = useState(true);
  const [oldPassword, setOldpassword] = useState("");
  const [newPassword, setNewpassword] = useState("");
  const [confirmPassword, setConfirmpassword] = useState("");
  const [color, setColor] = useState(null);
  const [loader, setLoader] = useState(false);
  const isMobile = window.innerWidth <= 600;
  const navigate = useNavigate();

  const handleLogout = () => {
    setOpenBox(false);
    setPassword(false);
    setHide(true);
    setHide2(true);
    setHide3(true);
    setConfirmpassword("");
    setNewpassword("");
    setColor(null);
    setOldpassword("");
    setLoader(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoader(true);
    const form = {
      id : data.id,
      old_password: oldPassword,
      password: newPassword,
    };

    if (newPassword === confirmPassword) {
      try {
        (data.entity==='sub_admin' ? handleSubAdminReset(form) : handleUpdatePassword(form))
          .then((response) => {
            toast.success(response?.data?.message, {
              position: isMobile ? "top-left" : "top-center",
              style: {
                width: isMobile ? "300px" : "400px",
                textWrap: isMobile && "wrap",
              },
            });
            localStorage.clear("data");
            navigate("/");
            setLoader(false);
            setNewpassword("");
            setConfirmpassword("");
            setOldpassword("");
          })
          .catch((error) => {
            handleToast(error?.response?.data);
            setLoader(false);
          });
      } catch (error) {
        console.log(error);
        handleToast(error?.response?.data);
        setLoader(false);
      }

      // API Call
    } else {
      setColor(true);
    }
  };

  const handleConfirm = (e) => {
    const value = e.target.value;
    setConfirmpassword(value);
    if (value.length >= newPassword.length) {
      if (value === newPassword) {
        setColor(false);
      } else {
        setColor(true);
      }
    } else {
      setColor(null);
    }
  };

  return (
    <div className="page-container">
      {/* Modal Overlay */}
      {openBox && (
        <div className="modal-overlay">
          <div className="modal-box">
            <button
              className="close-btn-box"
              style={{
                border: "none",
              }}
              type="botton"
              onClick={handleLogout}
            >
              ✕
            </button>

            {/* Profile Section */}
            <div className="profile-content">
              {!data.photo ? (
                <PeopleOutlineIcon
                  style={{
                    color: "black",
                    fontSize: "3rem",
                    background: "rgba(28, 28, 28, 0.11)",
                    padding: "4px",
                    marginBottom: "10px",
                    borderRadius: "20px",
                  }}
                />
              ) : (
                <img
                  src={data?.photo || ""}
                  alt="Avtar"
                  style={{
                    color: "black",
                    background: "rgba(28, 28, 28, 0.11)",
                    borderRadius: "10px",
                    width: "30px",
                    height: "30px",
                    border: "1px solid #1c1c1c",
                  }}
                />
              )}
              <h2 className="profile-name">{data.name}</h2>
              <p className="profile-role">{data.entity.replace("_", " ")}</p>
              <p className="profile-email">{data.emeil}</p>
              <button
                className="edit-btn"
                style={{
                  border: "none",
                  display: password && "none",
                }}
                onClick={() => {
                  setPassword(true);
                }}
              >
                Change Password
              </button>
              {password && (
                <>
                  {!loader ? (
                    <form
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                      onSubmit={handleSubmit}
                    >
                      <label
                        htmlFor=""
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "flex-start",
                          marginBottom: "7px",
                          marginLeft: "3px",
                        }}
                      >
                        {" "}
                        Old Password{" "}
                      </label>
                      <span id="password-box">
                        <input
                          style={{
                            padding: "7px 8px",
                            width: "300px",
                            border: "none",
                            borderRadius: "10px",
                          }}
                          value={oldPassword}
                          onChange={(e) => setOldpassword(e.target.value)}
                          id="newPassword"
                          placeholder="Enter your Old Password"
                          type={hide3 ? "password" : "text"}
                        />
                        <button
                          type="button"
                          style={{
                            border: "none",
                          }}
                        >
                          {hide3 ? (
                            <RemoveRedEyeIcon onClick={() => setHide3(false)} />
                          ) : (
                            <VisibilityOffIcon onClick={() => setHide3(true)} />
                          )}
                        </button>
                      </span>
                      <label
                        htmlFor=""
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "flex-start",
                          marginBottom: "7px",
                          marginLeft: "3px",
                          marginTop: "10px",
                        }}
                      >
                        {" "}
                        New Password{" "}
                      </label>
                      <span id="password-box">
                        <input
                          style={{
                            padding: "7px 8px",
                            width: "300px",
                            border: "none",
                            borderRadius: "10px",
                          }}
                          value={newPassword}
                          onChange={(e) => {
                            setNewpassword(e.target.value);
                            setColor(null);
                          }}
                          id="newPassword"
                          placeholder="Enter New Password"
                          type={hide ? "password" : "text"}
                        />
                        <button
                          type="button"
                          style={{
                            border: "none",
                          }}
                        >
                          {hide ? (
                            <RemoveRedEyeIcon onClick={() => setHide(false)} />
                          ) : (
                            <VisibilityOffIcon onClick={() => setHide(true)} />
                          )}
                        </button>
                      </span>
                      <p 
                        style={{
                          color:'red',
                          fontSize:'0.7rem',
                          marginLeft:'4px',
                          marginTop:'4px'
                        }}
                      >
                        { newPassword.length >= 1 &&  newPassword.length < 8  && "New Password length must be 8"}
                      </p>
                      <label
                        htmlFor=""
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "flex-start",
                          marginBottom: "7px",
                          marginLeft: "3px",
                          marginTop: "10px",
                        }}
                      >
                        Confirm Password{" "}
                      </label>
                      <span
                        id="password-box"
                        style={{
                          boxShadow: color
                            ? "0px 0px 4px red"
                            : color === false
                              ? "0px 0px 4px green"
                              : color === null && "none",
                        }}
                      >
                        <input
                          style={{
                            padding: "7px 8px",
                            width: "300px",
                            border: "none",
                            borderRadius: "10px",
                          }}
                          disabled={( newPassword.length >= 8 && newPassword )? false : true}
                          value={confirmPassword}
                          onChange={handleConfirm}
                          id="newPassword"
                          placeholder="Confirm Password"
                          type={hide2 ? "password" : "text"}
                        />
                        <button
                          type="button"
                          style={{
                            border: "none",
                          }}
                        >
                          {hide2 ? (
                            <RemoveRedEyeIcon onClick={() => setHide2(false)} />
                          ) : (
                            <VisibilityOffIcon onClick={() => setHide2(true)} />
                          )}
                        </button>
                      </span>
                      <span
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "flex-end",
                          width: "100%",
                        }}
                      >
                        <button
                          style={{
                            marginRight: "12px",
                            marginTop: "10px",
                            border: "none",
                            color : !(oldPassword && 
                            newPassword &&  
                            confirmPassword) && '#999'
                          }}
                          disabled ={ 
                            oldPassword && 
                            newPassword &&  
                            confirmPassword
                          }
                          type="submit"
                        >
                          Submit
                        </button>
                      </span>
                    </form>
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        hight: "260px",
                      }}
                    >
                      <CircularProgress style={{ color: "#F99234" }} />
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
